export default {
  namespaced: true,
  state: {
    tableData: {
      header: [
        { text: 'Тип устройства' },
        { text: 'Показы' },
        { text: 'Клики' },
        { text: 'CTR, %' },
        { text: 'CPC, руб.' },
        { text: 'Отказы, %' },
        { text: 'Расходы с НДС, руб.' },
        { text: 'Конверсии' },
        { text: 'CPL, руб.' },
        { text: 'CR, %' }
      ],
      rows: [
        [
          { text: 'Десктоп', icon: { className: 'desktop' } },
          { text: '0' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' }
        ],
        [{ text: 'Мобильные', icon: { className: 'mobile' } },
          { text: '0' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' }
        ],
        [{ text: 'Планшет', icon: { className: 'tablet' } },
          { text: '0' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0.00' },
          { text: '0' },
          { text: '0.00' },
          { text: '0.00' }
        ]
      ],
      footer: [
        { text: 'Итого' },
        { text: '0' },
        { text: '0' },
        { text: '0.00' },
        { text: '0.00' },
        { text: '0.00' },
        { text: '0.00' },
        { text: '0' },
        { text: '0.00' },
        { text: '0.00' }
      ]
    }
  },
  getters: {
    getTableData (state) {
      return state.tableData
    }
  }
}
